import { useEffect } from "react";
import { useParams, useNavigate, useLocation, Outlet } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";
import HreflangTags from "@/components/seo/HreflangTags";

/**
 * Wrapper component that syncs the URL language prefix with LanguageContext.
 * All localized routes are children of this component.
 */
const LanguageRouter = () => {
  const { lang } = useParams<{ lang: string }>();
  const { language, setLanguage } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (lang === "fr" || lang === "en") {
      if (lang !== language) {
        setLanguage(lang);
      }
    }
  }, [lang, language, setLanguage]);

  return (
    <>
      <HreflangTags />
      <Outlet />
    </>
  );
};

export default LanguageRouter;
